import { CityDTO } from '../../../http/dtos/geography/cities/citiesDTO';
import httpClient from '../../../http/httpClient';

export const citiesRepository = {
    GetCitiesList: () => {
        return httpClient.get('/cities').then((response: CityDTO[]) => response);
    },
};
